import { useDispatch, useSelector } from "react-redux"
import styled from "styled-components"
import Button from "../../shared/button/Btn"
import { useLocation } from "react-router-dom"
import { useEffect } from "react"
import { showNestedModal } from "../../../features/modal/modalSlice"
import { useScrollLock } from "../../../hooks/useScrollLock"
import PageTopTitle from "../../shared/PageTopTitle"
import { adminAraclarAracSilme } from "../../../features/admin2/admin2Slice"


const Container = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 100;

    .modal{
        width: 550px;
        height: auto;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        border-radius: 10px;
        padding-block: 20px;
        overflow: auto;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .content{
            padding: 20px;
            
        }
        .btn{
            padding-inline: 20px;
            display: flex;
            align-items: center;
            justify-content: center;
            button{
                margin-inline: 10px;
            }
        }
    }

`
    
const AdminAraclarAracSil = () => {

    const {modalLocation } = useSelector(state => state.modal)
    const dispatch = useDispatch()
    const location = useLocation()
    const { lockScroll, unlockScroll } = useScrollLock();
    const { selectAdminArac } = useSelector((state) => state.admin2);

    // //! bu modal açıldığnda ekran ı lock lamak için
    useEffect(() => {
    lockScroll()

    return () => {
        unlockScroll()
    }
    }, [lockScroll, unlockScroll])

    // //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
    useEffect(() => {
        if (location.pathname !== modalLocation) {
            dispatch(showNestedModal(null))
        }
    }, [dispatch, location.pathname, modalLocation])

    const selectedPlate = selectAdminArac.truckPlateNumber || selectAdminArac.trailerPlate;

  return (
    <Container onClick={()=> dispatch(showNestedModal(null))}>
        <div className="modal" onClick={(e)=> e.stopPropagation()}>
            <PageTopTitle title={"Araç Sil"}/>
            <div className="content">
                <p>Aracı Silmek İstediğinize Emin Misiniz?</p>
            </div>
            <div className="btn">
                <Button width="150px" handleClick={() => dispatch(adminAraclarAracSilme(selectedPlate))} padding="10px" bgColor="transparent" color={"#E85446"}>Sil</Button>
                <Button width="150px" handleClick={() => dispatch(showNestedModal(null))} padding="10px" bgColor="#E85446" color={"#fff"}>Kapat</Button>
            </div>
        </div>
    </Container>
  )
}

export default AdminAraclarAracSil